const componentStyles = (theme) => ({
  drawerPaper: {
    marginTop: 50,
    backgroundColor: theme.palette.primary.contrastText,
    paddingTop: 0
  },
  listRoot: {
    height: "100%",
  },
  listSub: {
    marginLeft: "0.75rem",
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItemRoot: {
    display: "flex",
    fontSize: ".9rem",
    color: theme.palette.sidebarLinks.main,
    padding: ".5rem 0.75rem !important",
    "&:hover": {
      color: theme.palette.sidebarLinks.dark,
      cursor: "pointer"
    },
  },
  listItemSelected: {
    fontWeight: "bold",
    color: theme.palette.sidebarLinks.dark,
    "&$listItemRoot,&$listItemRoot:hover": {
      backgroundColor: "unset",
    },
    "&:before": {
      top: ".25rem",
      bottom: ".25rem",
      left: 0,
      right: "auto",
      // borderLeft: "2px solid " + theme.palette.primary.main,
      borderBottom: 0,
      content: '""',
      position: "absolute",
    },
  },
  listItemIconRoot: {
    minWidth: "2.25rem",
    fontSize: ".9375rem",
    lineHeight: "1.5rem",
    display: "inline-block",
    top: "2px",
  },
  divider: {
    marginBottom: "1rem",
    marginTop: "1rem",
    marginLeft: "1.5rem",
    marginRight: "1.5rem",
  },
  icon: {
    color: theme.palette.sidebarLinks.main,
    "&:hover": {
      color: theme.palette.sidebarLinks.dark,
      cursor: "pointer"
    },
    marginRight: 10
  },
  title: {
    paddingTop: ".25rem",
    paddingBottom: ".25rem",
    fontSize: ".75rem",
    textTransform: "uppercase",
    letterSpacing: ".04em",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    color: theme.palette.gray[600],
  },
  logoBox: {
    backgroundColor: theme.palette.primary.contrastText,
    minHeight: 50,
    paddingBottom: "unset"
  },
  logoClasses: {
    maxHeight: "2rem",
    maxWidth: "100%",
    verticalAlign: "middle",
    borderStyle: "none",
    [theme.breakpoints.up("md")]: {
      maxHeight: "2.5rem",
    },
    margin: "0 10px"
  },
  logoLinkClasses: {
    fontSize: "1.25rem",
    lineHeight: "inherit",
    whiteSpace: "nowrap",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    height: "100%"
  },
  logoLinkText: {
    color: theme.palette.primary.main,
    margin: "12px 0 0 0",
    fontWeight: "bold",
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },
  textPrimaryLight: {
    color: theme.palette.primary.light,
  },
  textError: {
    color: theme.palette.error.main,
  },
  textErrorLight: {
    color: theme.palette.error.light,
  },
  textWarning: {
    color: theme.palette.warning.main,
  },
  textWarningLight: {
    color: theme.palette.warning.light,
  },
  textInfo: {
    color: theme.palette.info.main,
  },
  textInfoLight: {
    color: theme.palette.info.light,
  },
  menuPaper: {
    width: "calc(100% - 1rem)",
    backgroundColor: theme.palette.primary.main
  },
  outlineNone: {
    outline: "none!important",
  },
  close: {
    color: theme.palette.sidebarLinks.main
  }
});

export default componentStyles;
